import { render, staticRenderFns } from "./UImage.vue?vue&type=template&id=0da9103d&scoped=true&"
import script from "./UImage.vue?vue&type=script&lang=js&"
export * from "./UImage.vue?vue&type=script&lang=js&"
import style0 from "./UImage.vue?vue&type=style&index=0&id=0da9103d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da9103d",
  null
  
)

export default component.exports